// Stub for strategy signals WebSocket service - replace with actual implementation

export interface StrategySignalData {
  id: string;
  strategyId: string;
  type: string; // Generic string to avoid overlap issues
  signal?: string;
  price: number;
  timestamp: number;
  metadata?: any;
  data?: any;
}

export const strategySignalsWs = {
  connect: (id?: string, symbol?: string, type?: string) => {},
  disconnect: () => {},
  subscribe: (_strategyId: string) => () => {},
  unsubscribe: (_strategyId: string) => {},
  onSignalUpdate: (_callback: (data: StrategySignalData) => void) => () => {},
  on: (event: string, callback: any) => () => {},
};
